/* Easy Life Markets — marketplace behaviors (wishlist, recently viewed, tabs, quick add)
   Original vanilla JS authored for this theme. No external dependencies. */
(function () {
  "use strict";

  var WISHLIST_KEY = "elm_wishlist";
  var RECENT_KEY = "elm_recently_viewed";
  var RECENT_MAX = 12;

  function readList(key) {
    try {
      var raw = window.localStorage.getItem(key);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(key, list) {
    try {
      window.localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode, quota) - fail silently */
    }
  }

  /* ---------- Wishlist ---------- */
  var Wishlist = {
    get: function () {
      return readList(WISHLIST_KEY);
    },
    has: function (handle) {
      return this.get().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      var list = this.get();
      var idx = list.indexOf(handle);
      if (idx === -1) {
        list.push(handle);
      } else {
        list.splice(idx, 1);
      }
      writeList(WISHLIST_KEY, list);
      document.dispatchEvent(new CustomEvent("elm:wishlist:change", { detail: { list: list } }));
      return idx === -1;
    },
    clear: function () {
      writeList(WISHLIST_KEY, []);
      document.dispatchEvent(new CustomEvent("elm:wishlist:change", { detail: { list: [] } }));
    }
  };
  window.ElmWishlist = Wishlist;

  function refreshWishlistButtons() {
    var list = Wishlist.get();
    document.querySelectorAll("[data-elm-wishlist-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-elm-wishlist-toggle");
      var active = list.indexOf(handle) !== -1;
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest("[data-elm-wishlist-toggle]");
    if (!btn) return;
    evt.preventDefault();
    var handle = btn.getAttribute("data-elm-wishlist-toggle");
    Wishlist.toggle(handle);
  });
  document.addEventListener("elm:wishlist:change", refreshWishlistButtons);
  document.addEventListener("DOMContentLoaded", refreshWishlistButtons);

  /* Clear wishlist buttons */
  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest("[data-elm-wishlist-clear]");
    if (!btn) return;
    Wishlist.clear();
    var mount = document.querySelector("[data-elm-wishlist-mount]");
    if (mount) renderProductMount(mount, []);
  });

  /* ---------- Recently viewed ---------- */
  var RecentlyViewed = {
    record: function (handle) {
      if (!handle) return;
      var list = readList(RECENT_KEY).filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > RECENT_MAX) list = list.slice(0, RECENT_MAX);
      writeList(RECENT_KEY, list);
    },
    get: function () {
      return readList(RECENT_KEY);
    },
    clear: function () {
      writeList(RECENT_KEY, []);
    }
  };
  window.ElmRecentlyViewed = RecentlyViewed;

  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest("[data-elm-recent-clear]");
    if (!btn) return;
    RecentlyViewed.clear();
    var mount = document.querySelector("[data-elm-recent-mount]");
    if (mount) renderProductMount(mount, []);
  });

  /* Record current product page view */
  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector("[data-elm-record-view]");
    if (root) RecentlyViewed.record(root.getAttribute("data-elm-record-view"));
  });

  /* ---------- Render a list of product handles as cards via Shopify's product JSON endpoint ---------- */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format && format.indexOf("{{amount}}") !== -1) {
      return format.replace("{{amount}}", value);
    }
    return "$" + value;
  }

  function svgHeart() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 21s-6.7-4.35-9.3-8.28C.86 9.94 1.6 6.6 4.4 5.13c2.16-1.13 4.6-.5 6.1 1.3l1.5 1.8 1.5-1.8c1.5-1.8 3.94-2.43 6.1-1.3 2.8 1.47 3.54 4.81 1.7 7.59C18.7 16.65 12 21 12 21z"/></svg>';
  }

  function cardHTML(product) {
    var img = product.featured_image || (product.images && product.images[0]) || "";
    var v = product.variants && product.variants[0] ? product.variants[0] : {};
    var price = v.price || product.price || 0;
    var compareAt = v.compare_at_price || 0;
    var onSale = compareAt && compareAt > price;
    var discount = onSale ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
    return (
      '<div class="elm-card">' +
      '<a class="elm-card__media" href="' + product.url + '">' +
      (img ? '<img src="' + img + '" loading="lazy" alt="' + (product.title || "").replace(/"/g, "&quot;") + '">' : "") +
      (onSale ? '<span class="elm-card__badge">Sale</span>' : "") +
      "</a>" +
      '<button type="button" class="elm-card__wishlist" data-elm-wishlist-toggle="' + product.handle + '" aria-pressed="false" aria-label="Add to wishlist">' + svgHeart() + "</button>" +
      '<div class="elm-card__body">' +
      (product.vendor ? '<span class="elm-card__vendor">' + product.vendor + "</span>" : "") +
      '<p class="elm-card__title"><a href="' + product.url + '">' + product.title + "</a></p>" +
      '<div class="elm-card__prices">' +
      '<span class="elm-card__price">' + money(price) + "</span>" +
      (onSale ? '<span class="elm-card__compare">' + money(compareAt) + "</span>" : "") +
      (onSale ? '<span class="elm-card__discount">-' + discount + "%</span>" : "") +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  function renderProductMount(mount, handles) {
    if (!handles.length) {
      mount.innerHTML =
        '<div class="elm-empty"><p class="elm-empty__title">Nothing here yet</p><p>' +
        (mount.getAttribute("data-elm-empty-text") || "Products you view or save will show up here.") +
        "</p></div>";
      return;
    }
    mount.innerHTML = '<div class="elm-grid" aria-busy="true"></div>';
    var grid = mount.querySelector(".elm-grid");
    var fetches = handles.map(function (handle) {
      return fetch("/products/" + handle + ".js")
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    });
    Promise.all(fetches).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        renderProductMount(mount, []);
        return;
      }
      grid.innerHTML = valid.map(cardHTML).join("");
      grid.removeAttribute("aria-busy");
      refreshWishlistButtons();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var wishlistMount = document.querySelector("[data-elm-wishlist-mount]");
    if (wishlistMount) renderProductMount(wishlistMount, Wishlist.get());

    var recentMount = document.querySelector("[data-elm-recent-mount]");
    if (recentMount) {
      var handles = RecentlyViewed.get();
      var onProduct = document.querySelector("[data-elm-record-view]");
      if (onProduct) {
        handles = handles.filter(function (h) { return h !== onProduct.getAttribute("data-elm-record-view"); });
      }
      renderProductMount(recentMount, handles);
    }
  });

  document.addEventListener("elm:wishlist:change", function () {
    var wishlistMount = document.querySelector("[data-elm-wishlist-mount]");
    if (wishlistMount) renderProductMount(wishlistMount, Wishlist.get());
  });

  /* ---------- Tabs (Trending / New items) ---------- */
  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest(".elm-tabs__btn");
    if (!btn) return;
    var tabs = btn.closest("[data-elm-tabs]");
    if (!tabs) return;
    tabs.querySelectorAll(".elm-tabs__btn").forEach(function (b) {
      b.setAttribute("aria-selected", b === btn ? "true" : "false");
    });
    var targetId = btn.getAttribute("aria-controls");
    tabs.querySelectorAll(".elm-tabs__panel").forEach(function (p) {
      p.hidden = p.id !== targetId;
    });
  });

  /* ---------- Quick add (adds default/first available variant) ---------- */
  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest("[data-elm-quickadd]");
    if (!btn) return;
    evt.preventDefault();
    var variantId = btn.getAttribute("data-elm-quickadd");
    if (!variantId) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = "Added ✓";
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = "Try again";
        btn.disabled = false;
      });
  });
})();
